<template>
  <div class="receivablesInfo">
    <base-form
      v-model="baseData"
      :options="baseDataOptions"
      ref="baseData"
      @input="handleChangeBaseData"
      label-width="105px"
    ></base-form>
  </div>
</template>
<script>
  import baseForm from '@/components/form/base-form';
  import { mapState } from 'vuex';
  // import API from '@/api/capitalCenter/receivablesManage';
  import PAYMENT_API from '@/api/financeCenter/paymentApply.js';

  export default {
    name: 'receivablesInfo',
    components: {
      baseForm,
    },
    props: ['canEdit', 'companyCode', 'receiveStatus', 'departmentCode'],
    data() {
      return {
        baseData: {
          payerCode: null, // 付款单位
          payerName: null, // 付款单位名称
          payerType: null, // 付款单位类型
          payBankNo: null, // 付款银行
          payBankName: null, // 付款银行名称
          payBankAccount: null, // 付款银行账号
          bankFlowNo: null, // 银行流水号
          originReceiveMoneyAmount: null, // 收款金额
          localReceiveMoneyAmount: null, // 收款金额（本币）
          originProformaInvoiceAmount: null, // 形式发票金额
          localProformaInvoiceAmount: null, // 形式发票金额（本币）
          originDomesticBankDeductFee: null, // 国内银行扣费
          localDomesticBankDeductFee: null, // 国内银行扣费（本币）
          originForeignBankDeductFee: null, // 国外银行扣费
          localForeignBankDeductFee: null, // 国外银行扣费（本币）
          receiveInfoCurrencyCode: null, // 币别
          receiveInfoCurrencyName: null, // 币别名称
          exchangeRate: null, // 汇率
          exchangeType: null, // 汇率类型
          summary: null, // 摘要
          basicInfoCurrencyCode: null, // 本币
          isAnotherPay: null, // 是否代付
          anotherPayTime: null, // 代付时间
          financeAuditStatus: null, // 财务审核状态
          fmSendFlag: null, // 上报状态
        },
        fmSendFlagList: [
          { value: '1', label: '未上报' },
          { value: '2', label: '已上报' },
        ], //上报状态下拉列表
        partnersBanks: [],
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        // dictList: (state) => state.dict.dictList,
      }),
      //基础数据表单配置
      baseDataOptions() {
        return [
          {
            // 付款单位
            type: 'searchTable',
            prop: 'payerName',
            searchType: 'partner',
            isMultiple: true,
            label: this.$t('receivablesManage.receivablesInfo.payerCode'),
            currentValue: this.baseData.payerName,
            extraData: {
              companyCode: this.companyCode,
              partnerTypes: 'HZHB01,HZHB02,HZHB03', // 客户、供应商、合作伙伴
            },
            required: true,
            disabled: !this.canEdit,
          },
          {
            // 付款银行
            type: 'select',
            label: this.$t('receivablesManage.receivablesInfo.payBankName'),
            prop: 'payBankName',
            options: this.partnersBanks,
            disabled: !this.canEdit,
            filterable: true,
          },
          {
            // 付款银行账号
            type: 'input',
            label: this.$t('receivablesManage.receivablesInfo.payBankAccount'),
            prop: 'payBankAccount',
            disabled: true,
          },
          {
            // 银行流水号
            type: 'input',
            label: this.$t('receivablesManage.receivablesInfo.bankFlowNo'),
            prop: 'bankFlowNo',
            required: this.userInfo.businessGroup == '物贸',
            disabled: !this.canEdit,
          },
          {
            // 收款金额
            type: 'amountNumber',
            label: this.$t('receivablesManage.receivablesInfo.originReceiveMoneyAmount'),
            prop: 'originReceiveMoneyAmount',
            required: true,
            disabled: !this.canEdit,
          },
          {
            // 收款金额（本币）
            type: 'amountNumber',
            label: this.$t('receivablesManage.receivablesInfo.localReceiveMoneyAmount'),
            prop: 'localReceiveMoneyAmount',
            disabled: true,
            placeholder: this.$t('receivablesManage.placeholder.auto'),
          },
          /* {
            // 形式发票金额
            type: 'amountNumber',
            label: this.$t('receivablesManage.receivablesInfo.originProformaInvoiceAmount'),
            prop: 'originProformaInvoiceAmount',
            disabled: !this.canEdit,
          },
          {
            // 形式发票金额（本币）
            type: 'amountNumber',
            label: this.$t('receivablesManage.receivablesInfo.localProformaInvoiceAmount'),
            prop: 'localProformaInvoiceAmount',
            disabled: true,
            placeholder: this.$t('receivablesManage.placeholder.auto'),
          },
          {
            // 国内银行扣费
            type: 'amountNumber',
            label: this.$t('receivablesManage.receivablesInfo.originDomesticBankDeductFee'),
            prop: 'originDomesticBankDeductFee',
            disabled:
              !this.canEdit ||
              this.baseData.originForeignBankDeductFee ||
              this.baseData.originForeignBankDeductFee === 0,
          },
          {
            // 国内银行扣费（本币）
            type: 'amountNumber',
            label: this.$t('receivablesManage.receivablesInfo.localDomesticBankDeductFee'),
            prop: 'localDomesticBankDeductFee',
            disabled: true,
            placeholder: this.$t('receivablesManage.placeholder.auto'),
          },
          {
            // 国外银行扣费
            type: 'amountNumber',
            label: this.$t('receivablesManage.receivablesInfo.originForeignBankDeductFee'),
            prop: 'originForeignBankDeductFee',
            disabled:
              !this.canEdit ||
              this.baseData.originDomesticBankDeductFee ||
              this.baseData.originDomesticBankDeductFee === 0,
          },
          {
            // 国外银行扣费（本币）
            type: 'amountNumber',
            label: this.$t('receivablesManage.receivablesInfo.localForeignBankDeductFee'),
            prop: 'localForeignBankDeductFee',
            disabled: true,
            placeholder: this.$t('receivablesManage.placeholder.auto'),
          }, */
          {
            // 币别
            type: 'dict',
            dictType: 'all_currency',
            label: this.$t('receivablesManage.receivablesInfo.receiveInfoCurrencyCode'),
            prop: 'receiveInfoCurrencyCode',
            required: true,
            disabled: !this.canEdit,
          },
          ...(this.$route.name.indexOf('claim') == -1
            ? [
                {
                  // 汇率
                  type: 'amountNumber',
                  label: this.$t('receivablesManage.receivablesInfo.exchangeRate'),
                  prop: 'exchangeRate',
                  maxlength: '10',
                  required: true,
                  disabled: !this.canEdit,
                },
              ]
            : []),
          /* {
            // 上报状态
            type: 'select',
            label: '上报状态',
            prop: 'fmSendFlag',
            options: this.fmSendFlagList,
            disabled: true,
          }, */
          {
            // 摘要
            type: 'textarea',
            label: this.$t('receivablesManage.receivablesInfo.summary'),
            prop: 'summary',
            clearable: true,
            maxlength: 256,
            span: 20,
            disabled: !this.canEdit,
          },
          {
            // 是否代付
            type: 'checkbox',
            text: this.$t('receivablesManage.receivablesInfo.isAnotherPay'),
            prop: 'isAnotherPay',
            disabled:
              this.$route.name.indexOf('Receipt') != -1 ||
              this.$route.name.indexOf('claim') != -1 ||
              (this.baseData.financeAuditStatus && this.baseData.financeAuditStatus != '003') ||
              !this.canEdit,
          },
          /* ...(this.baseData.isAnotherPay
            ? [
                {
                  // 代付时间
                  type: 'date',
                  label: this.$t('receivablesManage.receivablesInfo.anotherPayTime'),
                  prop: 'anotherPayTime',
                  required: this.baseData.isAnotherPay,
                  disabled:
                    this.$route.name.indexOf('Receipt') != -1 ||
                    (this.baseData.financeAuditStatus && this.baseData.financeAuditStatus != '003'),
                },
                {
                  // 财务审核状态
                  type: 'dict',
                  dictType: 'financeAuditStatusForRecieve',
                  label: this.$t('receivablesManage.receivablesInfo.financeAuditStatus'),
                  prop: 'financeAuditStatus',
                  disabled: true,
                },
              ]
            : []), */
        ];
      },
      //判断汇率是否可修改
      exchangeRateDisable() {
        //【ID1001693】 汇率当前处理规则
        //3.1 收款登记（状态待认领）之前可修改；
        //3.2 收款单 （状态已保存）之前可修改；
        return this.$route.name.indexOf('claim') != -1 ||
          (this.receiveStatus && this.receiveStatus != '00' && this.receiveStatus != '01')
          ? true
          : false;
      },
    },
    mounted() {
      if (this.$route.name.indexOf('add') != -1) {
        this.getLoaclCurrency(this.userInfo.companyCode);
      }
    },
    methods: {
      //基本数据表单变化
      handleChangeBaseData(value, prop) {
        if (prop == 'payerName') {
          this.payerChange(value.payerName);
        }
        // 币种
        if (prop == 'receiveInfoCurrencyCode') {
          this.currencyChange(value.receiveInfoCurrencyCode);
        }
        // 汇率类型
        if (prop == 'exchangeType') {
          this.$emit('getRate');
        }
        if (prop == 'originProformaInvoiceAmount') {
          this.calcOriginForeignBankDeductFee();
        }
        if (prop == 'payBankName') {
          this.payBankNameChange(value.payBankName);
        }
        /* if (prop == 'isAnotherPay') {
          this.$emit('saveAnotherPay', this.baseData.isAnotherPay, this.baseData.anotherPayTime);
        }
        if (prop == 'anotherPayTime') {
          this.$emit('saveAnotherPayTime', this.baseData.anotherPayTime);
        } */
        // 计算本币
        // 声明原币prop
        this.calcLocalAmountAll(prop);
      },
      payBankNameChange(val) {
        /* if (val && val.length > 0) {
          this.baseData.payBankName = val[0].branchName;
        } else {
          this.baseData.payBankName = null;
        } */
        if (val) {
          let item = this.partnersBanks.find((i) => i.value == val);
          this.baseData.payBankNo = item.associatedLineNumber;
          this.baseData.payBankName = item.accountBankBranch;
          this.baseData.payBankAccount = item.bankAccount;
        } else {
          this.baseData.payBankNo = this.baseData.payBankName = this.baseData.payBankAccount = '';
        }
      },
      async payerChange(value) {
        this.partnersBanks = null;
        this.baseData.payBankNo = this.baseData.payBankName = this.baseData.payBankAccount = '';
        if (value && value.length > 0) {
          this.baseData.payerName = value[0].partnerZhName;
          this.baseData.payerCode = value[0].partnerCode;
          let params = {
            payerName: this.baseData.payerName,
            payerCode: this.baseData.payerCode,
            registerCompanyCode: this.baseData.registerCompanyCode,
          };
          this.baseData.payerType = await this.$baseRequest.getPartnerType(params);
          this.getBankInfo(this.baseData.payerCode, this.companyCode, this.departmentCode);
        } else {
          this.baseData.payerName = null;
          this.baseData.payerCode = null;
          this.baseData.payerType = null;
        }
      },
      async getBankInfo(partnerCode, companyCode, departmentCode) {
        // 获取收票(收款)人对应银行
        if (partnerCode) {
          let res = await this.$axios.get(PAYMENT_API.GET_PARTER_BANK, {
            partnerCode,
            companyCode,
            departmentCode,
          });
          if (res) {
            if (res.data.code == 0) {
              console.log(res.data.data);
              this.partnersBanks = res.data.data.map((item) => {
                return {
                  ...item,
                  value: item.bankAccount,
                  label: item.accountBankBranch + '-' + item.bankAccount,
                };
              });
              if (res.data.data && res.data.data.length == 1) {
                let tempData = res.data.data[0];
                this.baseData.payBankNo = tempData.associatedLineNumber;
                this.baseData.payBankName = tempData.accountBankBranch;
                this.baseData.payBankAccount = tempData.bankAccount;
              }
            } else {
              this.$message({ showClose: true, message: res.data.msg, type: 'error' });
            }
          }
        }
      },
      // 币种
      currencyChange(value) {
        this.baseData.receiveInfoCurrencyName = value
          ? this.dictListMap.all_currency.find((item) => item.value == value).label
          : null;
        this.$emit('getRate');
      },
      // 国外银行扣费计算
      calcOriginForeignBankDeductFee() {
        if (!this.baseData.originDomesticBankDeductFee) {
          this.baseData.originForeignBankDeductFee =
            this.baseData.originProformaInvoiceAmount - this.baseData.originReceiveMoneyAmount;
          if (this.baseData.originForeignBankDeductFee < 0) {
            this.baseData.originForeignBankDeductFee = 0;
          }
        }
      },
      resetPayer() {
        // 付款单位重置
        this.baseData.payerCode = this.baseData.payerName = this.baseData.payerType = null;
      },
      // 获取公司对应本币
      async getLoaclCurrency(companyCode) {
        if (companyCode) {
          let res = await this.$baseRequest.getLedger(companyCode);
          // let obj = {};
          if (res) {
            if (res.length > 0) {
              //默认汇率类型
              // this.baseData.exchangeType = res[0].defaultExchangeType
              //【ID1001693】汇率当前处理规则
              //收付款单据的汇率类型，默认为用户类型。值取当日的汇率值。
              this.baseData.exchangeType = 'User';
              this.baseData.receiveInfoCurrencyName = this.baseData.basicInfoCurrencyName =
                res[0].currencyName;
              this.baseData.receiveInfoCurrencyCode = this.baseData.basicInfoCurrencyCode =
                res[0].currencyCode;
            } else {
              //没有查询到公司账套
              this.$alert(this.$t('receivablesManage.message.ledgerInfo'));
              this.baseData.exchangeType = null;
              this.baseData.receiveInfoCurrencyName = this.baseData.basicInfoCurrencyName = null;
              this.baseData.receiveInfoCurrencyCode = this.baseData.basicInfoCurrencyCode = null;
              // 清空公司信息
              this.$emit('resetCompany');
            }
          }
        } else {
          this.baseData.exchangeType = null;
          this.baseData.receiveInfoCurrencyName = this.baseData.basicInfoCurrencyName = null;
          this.baseData.receiveInfoCurrencyCode = this.baseData.basicInfoCurrencyCode = null;
        }
        this.currencyChange(this.baseData.receiveInfoCurrencyCode);
      },
      // 计算所有本币
      calcLocalAmountAll(prop) {
        let originAmountProps = [
          'originProformaInvoiceAmount',
          'originReceiveMoneyAmount',
          'originDomesticBankDeductFee',
          'originForeignBankDeductFee',
        ];
        originAmountProps.map((item) => {
          if (prop && prop == item) {
            return (this.baseData['local' + prop.split('origin')[1]] = this.calcLocalAmount(
              this.baseData[prop]
            ));
          } else {
            return (this.baseData['local' + item.split('origin')[1]] = this.calcLocalAmount(
              this.baseData[item]
            ));
          }
        });
        this.$emit('getAmountData');
      },
      // 计算本币
      calcLocalAmount(originAmount) {
        if (this.baseData.exchangeRate && originAmount) {
          return this.$cal.calCommon(originAmount, this.baseData.exchangeRate, '*', 'amount');
        } else {
          return null;
        }
      },
      // 返回数据
      exportChildData(btnType) {
        let baseData = { ...this.baseData };
        Object.keys(baseData).map((item) => {
          if (item.indexOf('is') == 0) {
            return (baseData[item] = baseData[item] ? 'Y' : 'N');
          }
        });
        if (btnType == '00' || btnType == '01' || btnType == '04') {
          // 点击提交，走校验
          let sign = false;
          this.$refs.baseData.$refs.ruleForm.validate((valid) => {
            if (valid) {
              let {
                originProformaInvoiceAmount,
                originReceiveMoneyAmount,
                originDomesticBankDeductFee,
                originForeignBankDeductFee,
              } = this.baseData;
              let validAmount = this.$cal.calCommon(
                originDomesticBankDeductFee
                  ? originDomesticBankDeductFee
                  : originForeignBankDeductFee,
                originReceiveMoneyAmount,
                '+'
              );
              if (originProformaInvoiceAmount && originProformaInvoiceAmount != validAmount) {
                this.$message({
                  showClose: true,
                  message: this.$t('receivablesManage.message.originProformaInvoiceAmountValid'),
                  type: 'error',
                });
                sign = false;
              } else {
                sign = true;
              }
            } else {
              sign = false;
            }
          });
          return sign ? baseData : false;
        } else {
          return baseData;
        }
      },
    },
    watch: {
      baseData: {
        handler() {
          this.$emit('updateFormData');
        },
        deep: true,
      },
      'baseData.originReceiveMoneyAmount': {
        handler() {
          // 查看状态禁用
          if (!this.canEdit) return;
          this.calcOriginForeignBankDeductFee();
          this.calcLocalAmountAll('originReceiveMoneyAmount');
        },
      },
      canEdit: {
        handler(newValue) {
          if (newValue && this.baseData.payerCode) {
            this.getBankInfo(this.baseData.payerCode, this.companyCode, this.departmentCode);
          }
        },
      },
    },
  };
</script>
<style lang="scss">
  .receivablesInfo {
    .el-col-20 {
      height: auto;
    }
  }
</style>
